import React, { useContext } from 'react';
import { View } from '@shared/components/View';
import { MBIconV2 } from '@shared/components/image';
import { MBListRow } from '@shared/components/list/row';
import { MBTextBody2Bold } from '@shared/components/typography';
import { ColorThemeContext } from '@shared/styles';
import { I18nKey, i18n } from '@shared/util/i18n';

interface Props {
  intervalValue: number;
  intervalPluralStringKey: I18nKey;
  isPressable: boolean;
  onPress(): void;
}

export function RepeatEveryLabel({
  intervalValue,
  intervalPluralStringKey,
  isPressable,
  onPress,
}: Props) {
  const colors = useContext(ColorThemeContext);

  return (
    <>
      <View paddingHorizontal={3} paddingTop={3}>
        <MBTextBody2Bold color={colors.foregroundActive}>
          {i18n('card.blocks.recurrenceInput.actionSheet.repeatEvery')}
        </MBTextBody2Bold>
      </View>
      <MBListRow
        title={i18n(intervalPluralStringKey, {
          count: intervalValue,
        })}
        image={
          <View fill center>
            <MBIconV2 name="repeat" color={colors.accent} />
          </View>
        }
        isHidingPressableIndicator={isPressable}
        onPress={onPress}
      />
    </>
  );
}
